import { formatDate } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-datetime-selector',
  templateUrl: './datetime-selector.component.html',
  styleUrls: ['./datetime-selector.component.scss']
})
export class DatetimeSelectorComponent implements OnInit {

  typeDatepicker!: string;
  startStringDate!: any;
  startDate!: NgbDate;
  hourInit!: any;
  minuteInit!: any;

  @Input() date: any;
  @Input() time: any;
  @Input() placeholder: string = 'Seleccionar fecha';
  @Output() saveDate: EventEmitter<any> = new EventEmitter<any>();
  @Input() dateEventSaved: any;

  formNewDate: FormGroup = new FormGroup({});
  @Input() notEditable: boolean = false;

  constructor(public formatter: NgbDateParserFormatter, private formBuilder: FormBuilder, private elRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.typeDatepicker && !this.elRef.nativeElement.contains(event.target)) {
      this.typeDatepicker = null;
    }
  }

  ngOnInit() {
    this.formNewDate = this.formBuilder.group({
      date: [, Validators.required],
    });
    if (this.dateEventSaved) {
      this.date = new Date(this.dateEventSaved);
    }
    if (this.date) {
      this.formNewDate.setValue({ date: this.date });
      this.startDate = new NgbDate(this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate());
      this.startStringDate = formatDate(this.date, 'dd/MM/yyyy', 'es');

      const hasExplicitTime = this.time !== null && this.time !== undefined && this.time !== '';

      // Si el formulario no tiene time (null/undefined), dejamos los placeholders HH/MM.
      if (hasExplicitTime) {
        this.hourInit = formatDate(this.date, 'HH', 'es');
        this.minuteInit = formatDate(this.date, 'mm', 'es');
      } else {
        this.hourInit = null;
        this.minuteInit = null;
      }
    }
  }

  openDatePicker(type: string) {
    if (this.notEditable) return;
    if (this.typeDatepicker) {
      this.typeDatepicker = null;
      return;
    }
    this.typeDatepicker = type;
  }

  saveStartDate(event: any) {
    const date = new Date(event);
    this.formNewDate.get('date').setValue(formatDate(date, 'yyyy-MM-dd', 'es'));
  }

  changeHourInit(event: any) {
    this.hourInit = event;
    this.saveConfig();
  }

  changeMinuteInit(event: any) {
    this.minuteInit = event;
    this.saveConfig();
  }

  saveConfig() {
    const dateInit = this.formNewDate.value.date;

    if (!dateInit) {
      return;
    }

    const hasHour = this.hourInit !== null && this.hourInit !== undefined && this.hourInit !== '';
    const hasMinute = this.minuteInit !== null && this.minuteInit !== undefined && this.minuteInit !== '';

    if (hasHour && hasMinute) {
      // Convertir a número para asegurar compatibilidad (0 es válido para medianoche)
      const hours = Number(this.hourInit);
      const minutes = Number(this.minuteInit);
      dateInit.setHours(hours);
      dateInit.setMinutes(minutes);
    } else {
      // Si no hay hora/minuto, dejamos 00:00 para que el padre reciba la fecha
      // pero mantenga la hora vacía (se interpreta como null en el componente padre).
      dateInit.setHours(0);
      dateInit.setMinutes(0);
    }

    this.formNewDate.value.date = dateInit;
    this.saveDate.emit(this.formNewDate.value.date);
  }

  isTimeInvalid(): boolean {
    const hasDate = !!this.formNewDate?.value?.date;
    const hasHour = this.hourInit !== null && this.hourInit !== undefined && this.hourInit !== '';
    const hasMinute = this.minuteInit !== null && this.minuteInit !== undefined && this.minuteInit !== '';

    // Sin fecha, no mostramos error
    if (!hasDate) {
      return false;
    }

    // Con fecha, si falta hora o minuto, marcamos error (campo obligatorio)
    if (hasDate && (!hasHour || !hasMinute)) {
      return true;
    }

    if (!hasHour || !hasMinute) {
      return false;
    }

    const hourNum = Number(this.hourInit);
    const minuteNum = Number(this.minuteInit);

    return (
      hourNum > 23 ||
      hourNum < 0 ||
      minuteNum < 0 ||
      minuteNum > 59 ||
      String(this.minuteInit).length > 2
    );
  }

  getDate(event: any) {
    if (event) {
      const date = new Date(event.year, event.month - 1, event.day, 0, 0, 0, 0);

      if (this.typeDatepicker == 'start') {
        this.startDate = event;
        this.formNewDate.controls['date'].setValue(date);
        this.startStringDate = formatDate(date, 'dd/MM/yyyy', 'es');
      }

    }
    this.saveConfig();
    this.typeDatepicker = null;
  }

}
